<template>
  <Card
    class="koc-default-collection-item-track"
    footer-text="WATCH NOW"
    :footer-link="FormattingService.formatUrl(item)"
  >
    <template #image>
      <a :href="FormattingService.formatUrl(item)">
        <div class="koc-default-collection-item-track-image">
          <div
            class="koc-default-collection-item-track-image-thumbnail"
            :style="`background-image: url(${state.imageUrl})`"
          />
          <div
            v-if="state.isCompleted"
            class="koc-default-collection-item-track-image-ribbon"
          />         
          <font-awesome-icon
            v-if="state.isCompleted"
            class="koc-default-collection-item-track-image-icon"
            :icon="['fa', 'medal']"
            color="#000000"
            size="lg"
          />  
        </div>
      </a>
    </template>
    <template #content>      
      <div
        :class="state.showTooltip ? 'koc-default-collection-item-track-content-progress-bar-tooltip-active' : 'koc-default-collection-item-track-content-progress-bar-tooltip'"
      >
        <span>{{ `${state.completedCourses} of ${state.courses} Courses Completed` }}</span>
      </div>

      <div  
        class="koc-default-collection-item-track-content-progress-bar"
        @mouseover="state.showTooltip = true"
        @mouseleave="state.showTooltip = false"
      >
        <div
          class="koc-default-collection-item-track-content-progress-bar-percentage"
          :style="`width: ${state.percentage}%;`"
        />          
      </div>      
      <div
        class="koc-default-collection-item-track-content"
      >
        <div class="koc-default-collection-item-track-content-title koc-title koc-montserrat">
          <a
            :href="FormattingService.formatUrl(item)"
            v-html="item.title"
          />
        </div>
        <div class="koc-default-collection-item-track-content-body">
          <p v-html="`${state.courses} Courses | ${state.lessons} Lessons`" />
        </div>
      </div>
    </template>       
  </Card>
</template>

<script src="./track.js"></script>
<style lang="scss" scoped src="./track.scss"></style>